module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2num"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('hr', {
    staticClass: "hrc"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2chap"
  }, [_vm._v("FROM REVELATION TO EMPIRE")]), _vm._v(" "), _c('p', {
    staticClass: "block-chap"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Then when the Sacred Months (the 1st, 7th, 11th, and 12th months of the Islamic calendar) have passed, then kill the Mushrikun")]), _vm._v(" ["), _c('span', {
    staticClass: "txit"
  }, [_vm._v("idolaters")]), _vm._v("] "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("wherever you find them, and capture them and besiege them, and prepare for them each and every ambush.”")])]), _vm._v(" "), _c('p', {
    staticClass: "att-chap"
  }, [_vm._v("—Quran 9:5")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_vm._v("Mecca")]), _vm._v(" "), _c('h3', {
    staticClass: "h3rb"
  }, [_vm._v("December 22, "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 609")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("T")]), _vm._v("he brightness was more disorienting than the total darkness that had enveloped him moments earlier. The mountain cave had been an escape from the chaos of the city below, a place of solitude and prayer for days on end—but now it ")]), _c('a', {
    attrs: {
      "id": "ch02nt43"
    }
  }, [_vm._v("had been transformed into something else entirely.")])]), _c('a', {
    attrs: {
      "id": "ch02nt43"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt43"
    }
  }, [_vm._v("Mecca itself was a bustling—some might say sinful—oasis in the middle of a vast, unforgiving desert. The shrine at its center, a cube of black stone containing idols of the many gods of Arabia, was the destination for thousands of travelers who came to pray. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("But, to the merchant in the cave, those thoughts seemed far away at the moment.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What had been a quiet, dark place had suddenly been filled with light and a booming voice that called out one word: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("iqra,")]), _vm._v(" which means “recite.” The command reverberated through the stillness of the cave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And recite he did. Arabic words filled his head. Words, the merchant had ultimately convinced himself, that were divine in origin. All those who bowed down to false gods would soon know—or be forced to know—the one true God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that")]), _vm._v(" God was currently in the presence of a forty-year-old merchant named Muhammad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the next twenty-two years Muhammad would have visions of the Archangel Gabriel transmitting to him the direct word of God over and over again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ordinary merchant had become a prophet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The life of Muhammad and the divine teachings he received, later compiled in the Quran, form the basis of Islam. Therefore, understanding his life and the contents of the book that 1.6 billion Muslims regard as the perfect, immutable, unchangeable word of God is essential to understanding the religion. The Quran, unlike the Bible, isn’t a collection of stories or revelations written in the third person by humans; it is Allah’s direct word, in his first-person voice. It cannot and will not ever be changed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Despite his being one of the most revered and important figures in history, shockingly little is known about Muhammad the man. Western scholars have been largely reluctant to apply the same standards of historical inquiry to Muhammad as they have to other religious leaders, such as Jesus. And their reluctance is easy to understand. Those, such as British scholar Tom Holland, who have dared to look deeply into Muhammad’s life ")]), _c('a', {
    attrs: {
      "id": "ch02nt44"
    }
  }, [_vm._v("have been subjected to death threats.")])]), _c('a', {
    attrs: {
      "id": "ch02nt44"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt44"
    }
  }, [_vm._v("Here’s ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("what we can say with near certainty: Muhammad was a person who lived in the Arabian desert from approximately "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 570 to 632. What we cannot say is exactly what went on in the sessions when he reportedly heard and recited the word of God. Complicating matters is the fact that it would be decades before those revelations would be systematically committed to paper as the complete Quran.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("After receiving his first revelation in a cave in the mountains, Muhammad returned to his home in Mecca. There he began preaching—first to his astonished family and friends, ")]), _c('a', {
    attrs: {
      "id": "ch02nt45"
    }
  }, [_vm._v("and then to others in his tribe. With a revelation reminiscent of the passion of Moses and the dedication of Jesus he condemned the polytheists and idolaters of Mecca who had strayed from the ways of God. He railed against the corruption and immorality pervading society.")])]), _c('a', {
    attrs: {
      "id": "ch02nt45"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("Much of Muhammad’s preaching resembled that of itinerant Christians and monks who occasionally ventured into Arabia, as well as that of the Jews who lived there. In fact, much of the Quran stresses the similarities between Christianity and Judaism and affirms the holiness of the Old and New Testaments and their prophets, from Moses to Jesus. The Quran even suggests that Jesus had predicted Muhammad’s coming:")])]), _c('p', {
    staticClass: "blockb"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt45"
    }
  }, [_vm._v("And (remember) when ‘Iesa (Jesus), son of Maryam (Mary), said: “O Children of Israel! I am the Messenger of Allah unto you confirming the Taurat [(Torah) which came] before me, and giving glad tidings of a Messenger to come after me, ")]), _c('a', {
    attrs: {
      "id": "ch02nt46"
    }
  }, [_vm._v("whose name shall be Ahmed. But when he (Ahmed, i.e., Muhammad) came to them with clear proofs, they said: “This is plain magic.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt46"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt46"
    }
  }, [_vm._v("Muhammad also taught, however, that Christians and Jews had perverted their religions and betrayed true faith in God: Christians worshipped Jesus Christ, which was tantamount to ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("idolatry, and Jews had ignored Jesus as a prophet and the importance of his message.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But, like Christianity and Judaism, Muhammad preached judgment and resurrection after a coming Day of Judgment. There was no god but God, whom he called Allah. While Christians and Jews shared a belief in one god, the tribes in and around Mecca were polytheists, and among those hundreds of gods they worshipped was one known as “Allah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Meccan polytheists did not take kindly to Muhammad’s message that, by worshipping false idols, they were offending the one true God. As a result, few people, except for Muhammad’s closest friends and families, had any interest in listening. The local townspeople of Mecca did not see a prophet but rather a man intent on disrupting the booming tourism industry they had built around their local shrines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shrines, of course, that were dedicated to many gods.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("The Satanic Verses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Muhammad was nothing if not a pragmatist. Frustrated by his inability to convert Mecca to Islam, Muhammad knew he had to come up with another option. And so the prophet became a politician.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Meccans offered him a deal. If he would worship the gods of Mecca for a year, then they would worship Allah for a year. Muhammad contemplated the proposition and asked for divine guidance. It was a difficult decision—he had, after all, derided the Meccan gods as false gods. Should he ignore or twist everything God had told him so far? Did the means justify the end? In response, he received a revelation: the three main gods of Mecca could be worshipped, for they had a special relationship with Allah.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("The conciliatory measure pleased the Meccans, but according to the Quran, it greatly angered Allah. The revelation, which would later become known as the “Satanic Verses,” had been a false one—")]), _c('a', {
    attrs: {
      "id": "ch02nt47"
    }
  }, [_vm._v("a result of trickery by the Devil.")])]), _c('a', {
    attrs: {
      "id": "ch02nt47"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt47"
    }
  }, [_vm._v("“Never did We send a Messenger or a Prophet before you,” the Quran says, “but when he did recite the revelation or narrated or spoke, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Shaitan")]), _vm._v(" (Satan) threw (some falsehood) in it. But Allah abolishes that which "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Shaitan")]), _vm._v(" (Satan) throws in. Then Allah establishes His Revelations. And ")]), _c('a', {
    attrs: {
      "id": "ch02nt48"
    }
  }, [_vm._v("Allah is All-Knower, All-Wise.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a shocking admission. Satan had apparently infiltrated the prophet’s revelation and corrupted the word of God. Who was to say that other parts of the Quran weren’t similarly compromised? Was Muhammad an infallible prophet, a flawed messenger, or something else entirely?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Satanic Verses remain a source of contention for Muslims today, as evidenced by the furious reaction to Salman Rushdie’s novel of the same name, which reaction included a fatwa from the ayatollah of Iran sanctioning Rushdie’s killing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At God’s behest, Muhammad later rescinded his offer of compromise, enraging the Meccans and further straining their relations with Muhammad and his followers.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("When Islam Turned Violent")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 622, thirteen years after Muhammad received his first revelation, the opposition of the Meccans had grown too much for the prophet. He and several hundred followers left Mecca and migrated to the nearby oasis town of Medina—a move that became one of the most significant events in Muslim history: the establishment of a separate community, or "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("umma,")]), _vm._v(" of believers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt48"
    }
  }, [_vm._v("As Muhammad consolidated power in Medina, his ranks ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("swelled with ")]), _c('a', {
    attrs: {
      "id": "ch02nt49"
    }
  }, [_vm._v("those convinced of the divinity of his message. Others, however, including Medina’s Jewish clans that rejected Muhammad’s claim to being a prophet in the tradition of Moses, Isaac, and Isaiah, were still skeptical.")])]), _c('a', {
    attrs: {
      "id": "ch02nt49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("These clans had been generally receptive to Muhammad’s message of monotheism at first—Muhammad had even prayed in the direction of Jerusalem to show his respect for the Jewish tradition and to underscore that Allah was the same god of the Torah and Bible—but as his power grew, Muhammad was preaching with increased hostility toward those who did not convert to Islam.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt49"
    }
  }, [_vm._v("While in Medina, Muhammad continued to receive revelations, but the ")]), _c('a', {
    attrs: {
      "id": "ch02nt50"
    }
  }, [_vm._v("tone of his message changed dramatically. For the first thirteen years, God’s revelations to him had reflected the fact that Muhammad led a beleaguered community in Mecca. The Quran stressed peaceful coexistence with others, if for no other reason than Muhammad didn’t have political power.")])]), _c('a', {
    attrs: {
      "id": "ch02nt50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But that all changed in Medina.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt50"
    }
  }, [_vm._v("The Medinan verses, as they are called by Islamic scholars, preach open warfare against perceived enemies and are the parts of the Quran most often cited by Islamic terrorists. Jihad is prescribed to defend the faith and vanquish its enemies. As Ibn Ishaq, Muhammad’s earliest biographer, recounted, “The apostle had not been given permission to fight or allowed to shed blood. . . . He had simply been ordered to call men to God and to endure insult and forgive the ignorant. . . . When [the Meccans] became insolent towards God and rejected His gracious purpose and accused His prophet of lying . . . He gave permission to his apostle to fight and to protect himself against ")]), _c('a', {
    attrs: {
      "id": "ch02nt51"
    }
  }, [_vm._v("those who wronged them and treated them badly.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt51"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("Muhammad now had divine approval to take action against his detractors, including Medina’s Jews, toward whom the Quran was not exactly complimentary:")])]), _c('p', {
    staticClass: "blockb"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("The Jews say: “Allah’s Hand is tied up (i.e., He does not give and spend of His Bounty).” Be their hands tied up and be they accursed for what they uttered. . . . We have put enmity and hatred amongst them till the Day of Resurrection. Every time they kindled the fire of war, Allah extinguished it; and they (ever) strive to make mischief on earth. And Allah ")]), _c('a', {
    attrs: {
      "id": "ch02nt52"
    }
  }, [_vm._v("does not like the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Mufsidun")]), _vm._v(" (mischief-makers).")])]), _c('a', {
    attrs: {
      "id": "ch02nt52"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt52"
    }
  }, [_vm._v("Jews are repeatedly described throughout the Quran as cunning deceivers and the fiercest enemies of Islam. As his chosen people, Allah had given them the first revelation through the prophet Moses (who, in the Quran, is an Islamic prophet whom the Jews disobey). This earns Allah’s wrath. “O you who believe!” the Quran says, “[t]ake not the Jews and the Christians as "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Auliya’")]), _vm._v(" (friends, protectors, helpers, etc.), they are but "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Auliya’")]), _vm._v(" to one another. And if any amongst you takes them as "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Auliya’,")])]), _c('a', {
    attrs: {
      "id": "ch02nt53"
    }
  }, [_vm._v("then surely he is one of them.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt53"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt53"
    }
  }, [_vm._v("Jews are further described as killers of prophets. They are rebellious against Muhammad’s rule (“Why do not the rabbis and the religious learned men forbid them from uttering sinful words and from eating illegal things? Evil indeed is that which ")]), _c('a', {
    attrs: {
      "id": "ch02nt54"
    }
  }, [_vm._v("they have been performing.”) and they are called “apes” and “pigs,” epithets still commonly used today by terrorists and anti-Semites.")])]), _c('a', {
    attrs: {
      "id": "ch02nt54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What to do with the troublesome Jews, some of whom had made assassination attempts on Muhammad’s life? His solution was to exile two of Medina’s Jewish tribes, execute the male members of a third, and confiscate all their property.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt54"
    }
  }, [_vm._v("With his opponents vanquished, Muhammad set about establishing the foundations of the Islamic community in Medina. He preached five pillars of faith: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("salat")]), _vm._v(" (ritual prayer five times a day), "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("zakat")]), _vm._v(" (almsgiving), "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hajj")]), _vm._v(" (pilgrimage), fasting for Ramadan, and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("shahadah")]), _vm._v(" (bearing witness to the unity of God and Muhammad’s ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("prophethood). Muhammad stood not only as a religious leader, but as a political one, acting as the Muslim community’s governor and judge.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There were plenty of positives to come from Muhammad’s application of the revelations he continued to receive. Moral and spiritual reform, for example, were very much part of his message; the brutal existence of nomadic desert life, in which women were often viewed as property, gave way to rules that upheld some basic rights (although still not as many as adult males); and the blood feuds that had torn apart and killed members of families for generations were deemed un-Islamic and outlawed.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Birth of an Empire")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("As Muhammad’s political clout grew in Medina he turned his attention back to those in Mecca who had rejected his message. Muhammad and the Muslims began to raid and loot passing caravans of Meccans. As long as the caravans were owned by non-Muslims, they were fair game. The Quran counseled no mercy until the enemies were defeated and ready to negotiate: “When ye meet the Unbelievers (in fight), smite at their necks. At length when ye have thoroughly subdued them, bind a bond firmly: thereafter (is time for) either generosity or ransom, ")]), _c('a', {
    attrs: {
      "id": "ch02nt55"
    }
  }, [_vm._v("until the way lays down it burdens.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Muhammad himself led his troops into battle, promising Paradise for any Muslim killed fighting on behalf of Allah. Their enemies would be consigned to the fiery pits of Hell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first jihad had begun.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt55"
    }
  }, [_vm._v("Muhammad amassed wealth as his armies raided the goods of merchants, racked up victories against marauding armies, and cut off Mecca from the trade that sustained it. He had no interest ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("in killing all Meccans, merely converting them. To that end, he agreed to a compromise that would make the polytheistic shrine in the middle of Mecca, the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("ka’ba,")]), _vm._v(" a holy shrine of Islam and required pilgrimage site for every Muslim. It was a shrewd move that ensured the money would keep flowing into Mecca.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Conquest continued with bloody battles in the Arabian Peninsula. Muhammad united most of the tribes of the Arabian Desert under his political and religious vision. Christians and Jews were allowed to remain in Muslim lands as long as they paid additional taxes. Muhammad provided protection in return for taxes and loyalty to the Islamic faith. Atheists and polytheists were forced to convert to Islam or else face execution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The violent anarchy of traditional nomadic life would be no more, as clans became a less important test of alliance than loyalty to the Muslim community. Being a Muslim meant—and still means—more than just a set of spiritual beliefs; it means identity with fellow believers. As Muhammad taught, Islam is not just a faith but complete "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("submission")]), _vm._v(" (a direct translation of the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("islam")]), _vm._v(") to a holistic political ideology and the inalterable laws established by Allah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What followed was a ruthless commitment to spread that ideology to the edges of the known world.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("An Expanding Caliphate")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Muhammad’s death in 632 resulted in chaos. He hadn’t left directions for who should succeed him as political leader of the growing faith, so a consensus among the powerful Medinan tribes selected a man named Abu Bakr. Bakr, along with the two leaders, or "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("caliphs,")]), _vm._v(" who succeeded him, amassed the most formidable armies the Middle East had ever seen. They vanquished the Persians in the East and the Byzantine Romans in the West.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The first four caliphs were associates or “Companions” of Muhammad. By virtue of their personal connection to the prophet the Companions were accepted as rulers by the Muslim community. But in a seventh-century desert version of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Game of Thrones,")]), _vm._v(" the power that came with leading a rapidly expanding religion and empire inevitably created epic struggles and wars.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Three of the first four caliphs were assassinated. In 661, the murder of the fourth caliph, Ali, who was a cousin and son-in-law of Muhammad, provoked a civil war and permanent schism between the groups that would eventually become today’s Sunni and Shia Muslims. Because of his connection by blood, the Shia believed that Ali’s son was the next in line to become caliph and that anyone other than Ali’s descendants was a false caliph. The Sunnis, by contrast, accepted the legitimacy of the Umayyad, Abbasid, ")]), _c('a', {
    attrs: {
      "id": "ch02nt56"
    }
  }, [_vm._v("and subsequent dynasties after Ali’s death.")])]), _c('a', {
    attrs: {
      "id": "ch02nt56"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt56"
    }
  }, [_vm._v("From 661 on, the two sects developed their own traditions and practices. One called themselves “Ahl al-Sunna,” the “people of the tradition”—or Sunni. The other, in memory of the man they believed to be the first and last true caliph, took the name “Shiat Ali”—")]), _c('a', {
    attrs: {
      "id": "ch02nt57"
    }
  }, [_vm._v("or Shia—the “party of Ali.” Rebellions and fighting occasionally broke out, but by and large the borders of the Caliphate expanded. As Europe was beset by a crumbling Roman Empire and warring feudal lords, a civilization grew in the East with Baghdad and Damascus becoming wealthy capital cities. By the beginning of the eighth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(", the borders of the Caliphate stretched from Spain to India.")])]), _c('a', {
    attrs: {
      "id": "ch02nt57"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt57"
    }
  }, [_vm._v("Despite the expansion, the loss of Muhammad’s divine revelations and leadership meant that uniting Muslims around a common direction proved to be a challenge. Muslims could not yet rely on the Quran, since it did not exist as a ")]), _c('a', {
    attrs: {
      "id": "ch02nt58"
    }
  }, [_vm._v("complete written document until years after Muhammad’s death, so instead turned to memories and written fragments of God’s direct word on leaves and bones; as well as the Hadith, oral traditions attributed to ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Muhammad by followers, which were later organized into several collections. Because the Quran was often contradictory and confusing, the Hadith became even more important in determining the rules for daily life.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("An entire class of Islamic scholars and lawyers emerged to make sense of what was valid and what was not, with bitter disagreements among them. There are hundreds of thousands of supposedly valid or “strong” Hadith, and most Muslims admit that there are many completely fraudulent or “weak” ones as well. Part of the reason for that is the significant time that elapsed between Muhammad’s life and the Hadith. The most authoritative of the Hadith collectors, al-Bukhari, was not even born until ")]), _c('a', {
    attrs: {
      "id": "ch02nt59"
    }
  }, [_vm._v("nearly 180 years after the prophet’s death.")])]), _c('a', {
    attrs: {
      "id": "ch02nt59"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Because politics and religion had been so thoroughly intertwined by Muhammad, there was no separation of church and state in Islam. The caliphs were both religious and political leaders. They established laws based on their understanding of the Quran and sayings of the prophet, the Hadith. These holy laws make up "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sharia,")]), _vm._v(" which in Arabic does not mean “law” but “the way” or “the pathway”—implying something much broader than law. Sharia is, in fact, an all-encompassing way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whenever the law is involved—or, to be more exact, whenever lawyers get involved—things get complicated. Almost immediately after Muhammad’s death, Islamic legal scholars wrangled with each other about what various Quranic passages meant, what Muhammad actually did and said, and what to do in cases where their existing sources offered no guidance.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt59"
    }
  }, [_vm._v("Different schools of legal thought began to emerge, and sharia or Islamic law began to be codified in a formal way. There was unanimity on the basics, and the Caliphate ensured that every Muslim living under its domain abided by them. In family law, for instance, a man could be married to up to four wives at any ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("given time. Slavery was permitted. In criminal law, adultery was punishable by death by stoning. A first offense of theft meant losing a right hand, and a second offense meant losing a left foot. In trials before judges, a woman’s testimony counted for half of a man’s. Blasphemy, or anything that might be taken as insulting to God or Muhammad, was one of the worst crimes. Depending on the school of law, there were different punishments. They ranged ")]), _c('a', {
    attrs: {
      "id": "ch02nt60"
    }
  }, [_vm._v("from fines to amputation to hanging or beheading.")])]), _c('a', {
    attrs: {
      "id": "ch02nt60"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt60"
    }
  }, [_vm._v("The severest crime in sharia is apostasy, or abandoning Islam by converting to another religion or atheism. From the Quran: “Whoever disbelieved in Allah after his belief, except him who is forced thereto and whose heart is at rest with Faith but such as open their breasts to disbelief, on them is wrath from Allah, and theirs ")]), _c('a', {
    attrs: {
      "id": "ch02nt61"
    }
  }, [_vm._v("will be a great torment.” In Muhammad’s lifetime, the specific “torment” was clear: death. A Muslim could be punished with death in three cases: murder, “a married person who commits illegal sexual intercourse,” and “one ")]), _c('a', {
    attrs: {
      "id": "ch02nt62"
    }
  }, [_vm._v("who reverts from Islam and leaves the Muslims.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt62"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Apostasy was such a severe crime because adherents of Islam considered Islam to be the final, perfect teaching of God. Those who replace it with something else have committed the gravest sin against God.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("House of War, House of Peace")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt62"
    }
  }, [_vm._v("Muhammad didn’t just bring the world another religion; he brought an empire that was on a collision course with neighboring regional powers and all those across the Middle East who didn’t think of themselves as Muslims. Both Muhammad and the Quran taught the supremacy of Islam over other religions and the political duty incumbent on every Muslim to spread the ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("faith by persuasion and example, and if necessary, by the sword as well. Unlike Judaism and Christianity, which began as persecuted minorities of believers, Islam was almost always associated with power and conquest.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sharia law developed an entire set of rules, laws, and traditions for non-Muslims. If they survived the initial waves of conquest, most non-Muslims lived a second-class existence. Using Muhammad’s example or "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sunna")]), _vm._v(" (way or tradition), Jews, Christians, and a religious group called Zoroastrians were allowed to retain their faith if they paid a tribute called a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("jizya.")]), _vm._v(" Because Christians and Jews bore some resemblance to Muslims in the way they venerated God’s prophets and their holy books such as the Bible, they would not be forced to convert to Islam. They would instead be considered "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dhimmi,")]), _vm._v(" “protected” or “guilty” people—the word means both in Arabic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though it is not mentioned in the Quran or in Muhammad’s Hadith, a concept emerged that delineated the world between Muslims and everyone else within the first decades of Islam. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Dar al-Islam,")]), _vm._v(" or the “house of Islam,” referred to lands and cultures where Muslims formed a majority, and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Dar al-sulh")]), _vm._v(" referred to non-Muslim nations that had agreed to a peace treaty with Muslims, often including payment of tribute. Everything outside of that was dubbed "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dar al-harb,")]), _vm._v(" or the “house of war.” Though there could be temporary truces lasting not more than ten years, there was a perpetual state of conflict between Islam and everyone else—a state that exists to this day.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The dividing line between the Muslim and non-Muslim communities, between the Islamic faithful and the unbelievers, became sharper and more humiliating as the Islamic Caliphate grew in power and scope: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dhimmi")]), _vm._v("s were second-class citizens, without the same rights Muslims had; non-Muslim religious symbols were prohibited from any public display; and the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("jizya")]), _vm._v(" tax could be a ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("crushing burden for non-Muslims. In addition, land and property could not be inherited between "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dhimmi")]), _vm._v("s and Muslims, meaning that if someone in a family had converted, there was an incentive for everyone else to convert as well.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("The Collapse of “The Islamic Golden Age”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("By "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 1200, Islam had enjoyed nearly half a millennium of continuous expansion since the time of Muhammad. Muslims had fulfilled their role as the newly chosen people of God who would inherit the earth through conquest and conversion. For five hundred years, it had worked brilliantly. Islamic conquest and conversion had reached well into Europe—as far north as France (halted only by a French duke named Charles Martel, who stopped the northward advance of Muslim armies ")]), _c('a', {
    attrs: {
      "id": "ch02nt63"
    }
  }, [_vm._v("at the Battle of Tours in 732).")])]), _c('a', {
    attrs: {
      "id": "ch02nt63"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt63"
    }
  }, [_vm._v("Islam and Christianity clashed throughout the time of the Crusades, but while Europe remained largely disunited under various feudal empires, the Caliphate flourished. The years 700 to 1250 marked the so-called Islamic Golden Age, a period that often gets romanticized by apologists as a time of tolerance and learning. In his 2009 speech in Cairo, Egypt, Barack Obama said that during this period Islam “carried the light of learning through so many centuries, paving the way for Europe’s Renaissance and Enlightenment.” He went on to praise the “innovation in Muslim communities that developed the order of algebra; our magnetic compass and tools of navigation; our mastery of pens and printing; our understanding of ")]), _c('a', {
    attrs: {
      "id": "ch02nt64"
    }
  }, [_vm._v("how disease spreads and how it can be healed.”")])]), _c('a', {
    attrs: {
      "id": "ch02nt64"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt64"
    }
  }, [_vm._v("A closer look reveals that the flourishing of Islam during this period was based not only on conquest, but also on cultural ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("reappropriation. Noted scholar of the Islamic world Bernard Lewis has pointed out that Muslim successes around this time were due largely to their military and trading power. “[Muslims,] at the very same time, were invading Europe and Africa, India and China,” Lewis wrote, as well as “trading in a wide range of commodities through a far-flung ")]), _c('a', {
    attrs: {
      "id": "ch02nt65"
    }
  }, [_vm._v("network of commerce and communications.” In the process they were inheriting ideas, inventions, and innovations. Muslim scholars translated the Greek philosophers Aristotle and Plato, as well as other great sources of ancient wisdom.")])]), _c('a', {
    attrs: {
      "id": "ch02nt65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There were sporadic bouts of violence between Muslims and religious minorities during the Islamic “Golden Age.” Though it is often portrayed as a time of cooperation and tolerance shown by Muslim rulers to minorities, the rise of the Islamic empire was not always kind to Jews and Christians. The first caliph declared that no Jew or Christian could live in Arabia, the sacred homeland of Islam, and so they were expelled to other parts of the Middle East. In 1066, mobs in Islamic-controlled Spain killed thousands of the area’s Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like all empires, Islam’s “Golden Age” eventually came to an end. In 1258, Mongol invaders sacked Baghdad, destroying the seat of the Caliphate. The Caliphate would go on to be inherited by the Ottoman Turks, but it would never again stretch as far across the Middle East or command the same influence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The decline of the Islamic empire wasn’t supposed to happen. Its armies had repulsed Crusades from the west and intruders from the east, but by 1300 the Caliphate was crumbling. In the centuries that followed, Europe underwent a renaissance—reclaiming Spain and Eastern Europe and going on to colonize much of North Africa and the Middle East.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02nt65"
    }
  }, [_vm._v("As the Quran and Muhammad both made clear, Muslims were God’s newly chosen people. Islam was supposed to expand, and the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dar al-harb")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("was supposed to shrink, giving way to a global Caliphate and world of believers. Yet precisely the opposite had happened. It was a world turned upside down.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What went wrong, as Bernard Lewis asked in the title of his 2001 book? What went wrong with the dream of the global Caliphate? How could Islam return to the promise of its founding? There were no shortage of people with answers to those questions.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 81
// module chunks = 0